import axios from '@/axios'
import BaseInfo from '@/model/modules/BaseInfo'

export default class BaseService {
  protected static baseUrl: string = ''

  public static delete(id: string): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      axios.delete(this.baseUrl + '/delete', {
        params: {
          id: id
        }
      })
        .then(resp => {
          resolve()
        })
        .catch(e => {
          reject(e)
        })
    })
  }

  public static save(i: BaseInfo): Promise<string> {
    return new Promise<string>((resolve, reject) => {
      axios.request({
        url: this.baseUrl + (i.id === undefined ? '/save' : '/update'),
        method: i.id === undefined ? 'post' : 'put',
        data: i
      })
        .then(resp => {
          resolve()
        })
        .catch(e => {
          reject(e)
        })
    })
  }

  public static getInfo<T>(id: string): Promise<T> {
    return new Promise<T>((resolve, reject) => {
      axios.get(this.baseUrl + '/detail/' + id)
        .then(resp => {
          resolve(resp.data.body)
        })
        .catch(e => {
          reject(e)
        })
    })
  }
}
